<template>
  <b-row
    no-gutters
    style="min-height: calc(100vh - 5rem);"
    :class="mobile ? 'flex-column' : ''"
    data-cy="agendamento-container"
  >
    <side-menu data-cy="agendamento-sidemenu"></side-menu>
    <b-col
      class="bg-white shadow-inset-top"
      :class="mobile ? 'flex-grow-1' : ''"
      data-cy="agendamento-content"
    >
      <b-row
        no-gutters
        class="d-flex flex-column p-4"
        data-cy="agendamento-inner-row"
      >
        <transition name="page" mode="out-in" data-cy="agendamento-transition">
          <router-view data-cy="agendamento-router-view" />
        </transition>
        <!-- <view-bottom-buttons /> -->
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import SideMenu from "@/components/sidemenu.vue";

export default {
  name: "appointment",
  components: {
    SideMenu
  },
  computed: {
    mobile() {
      return this.$store.getters.width < 768;
    }
  }
};
</script>

<style>
.shadow-inset-top {
  -moz-box-shadow: inset 0px 0.7rem 0.3rem -0.3rem rgba(0, 0, 0, 0.05),
    inset 0 -0.7rem 0.3rem -0.3rem rgba(0, 0, 0, 0.05) !important;
  -webkit-box-shadow: inset 0px 0.7rem 0.3rem -0.3rem rgba(0, 0, 0, 0.05),
    inset 0 -0.7rem 0.3rem -0.3rem rgba(0, 0, 0, 0.05) !important;
  box-shadow: inset 0px 0.7rem 0.3rem -0.3rem rgba(0, 0, 0, 0.05),
    inset 0 -0.7rem 0.3rem -0.3rem rgba(0, 0, 0, 0.05) !important;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
}
</style>
